import { Component, OnInit, ViewChild } from '@angular/core';
import { MessageService } from 'primeng/api';
import { IAppointment } from 'src/app/shared/interfaces/appointment';
import { EAppointmentStatus } from 'src/app/shared/interfaces/appointmentStatus-enum';
import { EPaymentStatus } from 'src/app/shared/interfaces/paymentStatus-ennum';
import { EVisitType } from 'src/app/shared/interfaces/visitType-enum';
import { FakeDataService } from 'src/app/shared/mock/fake-data.service';
import { ModalComponent } from 'src/app/shared/modals/modal.component';
import { ShamsiDatePipe } from 'src/app/shared/pipes/shamsiDatePipe';
import { ApiService } from 'src/app/shared/services/api.service';
import { DateService } from 'src/app/shared/services/date.service';
import { ImageCroppedEvent, LoadedImage } from 'ngx-image-cropper';


@Component({
  selector: 'app-appointment-list',
  templateUrl: './appointment-list.component.html',
  styleUrl: './appointment-list.component.css',
  providers: [MessageService]
})
export class AppointmentListComponent implements OnInit {

  drId: any = 7;
  tempVisit: IAppointment;
  appointmentsList: IAppointment[];
  visitType = EVisitType;
  appointmentStatus: EAppointmentStatus;
  paymentStatus= EPaymentStatus;
  visitStatus = EAppointmentStatus;
  searchBody = {
      // id: 0,
      title: '',
      pageIndex: 1,
      pageSize: 10,
      type: null,
      status: null,
      paymentStatus: null
  }
  todayDate: any;
  visitId: any;

  first: number = 0 ;
  rows: number = 10;
  pageSize = 10;  
  currentpage = 1;
  collectionSize: number = 10;


  @ViewChild('modal') modal!: ModalComponent;
  @ViewChild('image') image!: ModalComponent;
  @ViewChild('drFile') drFile!: ModalComponent;


  // -------------------Image----------------
  // file: any;
  localUrl: File = null;
  localCompressedURl: any;
  sizeOfOriginalImage: number;
  sizeOFCompressedImage: number;
  imgResultBeforeCompress: string;
  imgResultAfterCompress: string;
  showCropper = false;
  imageChangedEvent: File = null;
  croppedImage: any;

  url: any;
  imgFile: any;

  constructor(
    private fakeData: FakeDataService,
    public apiService: ApiService,
    private dateService: DateService,
    private dateShamsi: ShamsiDatePipe,
    private messageService: MessageService
  ){}

  ngOnInit(): void {
    this.todayDate = this.dateService.getTodayPersianDate();
    // console.log(this.todayDate);


    this.getAppointmentList(1);
  }

  convertUTCMinutesToLocal(utcMinutes: number): number | any {
    // Get the current date (ignoring time) in UTC
    const utcDate = new Date();
    utcDate.setUTCHours(0, 0, 0, 0); // Reset to 00:00 UTC
  
    // Add UTC minutes to the date
    utcDate.setUTCMinutes(utcMinutes);
  
    // Convert to local time
    const localHours = utcDate.getHours(); // Local hours
    const localMinutes = utcDate.getMinutes(); // Local minutes
  
    // Convert local time to total minutes from 00:00 local time
    return this.calculateTime(localHours * 60 + localMinutes);
  }

  // This function checks if the visit time passed, the buttons will become disabled 
  isActiveVisitLink(date, startVisit): boolean {

    // const now = new Date();
    // const currentMinutes = now.getHours() * 60 + now.getMinutes();

    // if(this.todayDate.slice(0,10) > date.slice(0,10) && currentMinutes > startVisit) {      
    //   return true;
    // }

    const now = new Date();
    const currentMinutes = now.getHours() * 60 + now.getMinutes();

    // Convert UTC startVisit to local minutes
    const utcDate = new Date(date);
    utcDate.setUTCHours(0, 0, 0, 0); // Reset to 00:00 UTC
    utcDate.setUTCMinutes(startVisit);

    // Get local time from UTC date
    const localHours = utcDate.getHours();
    const localMinutes = utcDate.getMinutes();
    const startVisitLocal = localHours * 60 + localMinutes;

    // Check if the visit time has passed
    if (this.todayDate.slice(0, 10) > date.slice(0, 10) || currentMinutes > startVisitLocal) {
        return true;
    }

    return false;
    
  }

  getAppointmentList(page) {
    // this.fakeData.getAppointments().subscribe((res: IAppointment[]) => {
    //   this.appointmentsList = res;
    // })

    this.searchBody = {
      // id: 0,
      title: this.searchBody.title,
      pageIndex: page,
      pageSize: 10,
      type: Number(this.searchBody.type),
      status: Number(this.searchBody.status),
      paymentStatus: Number(this.searchBody.paymentStatus)
    }
    console.log(this.searchBody);
    
    this.apiService.apiCall('post', '/api/Doctor/GetAllVisit', this.searchBody).subscribe((res: any) => {
      console.log(res);

      this.appointmentsList = res.body.model;
      this.collectionSize = res.body.collectionSize;
    })

  }

  calculateTime(time) {
    const hours = Math.floor(time / 60);
    const minutes = time % 60;
    // Format the time as HH:mm
    const timeString = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
    return timeString
  }
  
  visitCancel() {
    this.apiService.apiCall('post', '/api/Doctor/CancelVisit/'+this.visitId).subscribe((res: any) => {
      console.log(res);
      
      if (res.body.isSuccess == true) {
        this.modal.close();
        
        this.messageService.add({severity: 'success', summary: 'موفق', detail: 'ویزیت شما با موفقیت لغو شد.' });
      } else {
        this.messageService.add({severity: 'error', summary: 'خطا', detail: res.body.message });
      }
    })
  }

  getFileExtension(fileName: string): string | null {
    return fileName?.includes('.') ? fileName?.split('.').pop() : null;
  }

  ////////////////////////// Managing upload image

  addFile() {
    const fileType = this.getFileExtension(this.imgFile.name);

    var drPrescription = new FormData();
    drPrescription.append('file', this.imgFile);
    drPrescription.append('visitid', this.tempVisit.id.toString());
    drPrescription.append('isIMG', fileType=='pdf'?'false':'true');

    for (var pair of drPrescription.entries()) {
      console.log(pair[0]+ ', ' + pair[1]); 
    }
    
    this.apiService.callFormDataApi('/api/Doctor/AddFileVisit', drPrescription).subscribe((res: any) => {
      console.log(res);
      
      if (res.body.isSuccess == true) {
        this.messageService.add({severity: 'success', summary: 'موفق', detail: 'فایل با موفقیت بارگزاری شد.' });
        this.image.close()
      } else {
        this.messageService.add({severity: 'error', summary: 'خطا', detail: res.body.message });
      }
    })
  }

  onSelectFile(event) {    
    
    const input = event.target as HTMLInputElement;
    if (input.files?.length) {
      this.imgFile = input.files[0];

      if(this.getFileExtension(this.imgFile.name)=='pdf') {
        this.addFile();
        this.drFile.close();
      } else {
        this.imageChangedEvent = event;
        this.drFile.close();
        this.image.open();
      }
    }
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();

      reader.readAsDataURL(event.target.files[0]); // read file as data url

      reader.onload = (event1) => { // called once readAsDataURL is completed
        this.url = event1.target.result;       
        // this.newCategory.imgFile = this.url;
      }
      
    }

  }

  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;

  }
  imageLoaded(image: LoadedImage) {
    this.showCropper = true;
    // show cropper
  }
  cropperReady() {
    // cropper ready
  }
  loadImageFailed() {
    // show message
  }


}
